import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtIDR } from "../../lib/api";
import { errMsg } from "../admin/ui";
import { Stars } from "./shared";

export default function ReputationTable() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/reputation").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const unblock = async (s) => {
    const reason = window.prompt(`Alasan membuka pembatasan TAKE ORDER untuk ${s.name} (min. 5 karakter):`);
    if (!reason) return;
    try { await api.post(`/admin/suppliers/${s.id}/take-unblock`, { reason }); toast.success("Pembatasan dibuka & tercatat"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="reputation-table" className="bg-[#202127] border border-[#35353B] rounded-lg p-4 sm:p-6 overflow-x-auto">
      <p className="text-xs text-[#A8A8AD] mb-4">Reputasi dihitung otomatis dari alokasi nyata: rating = tingkat penyelesaian (selesai ÷ (selesai + pelanggaran)) dalam skala 1–5. Peringatan pada 2 pelanggaran, TAKE ORDER diblokir pada 3.</p>
      <table className="w-full text-sm min-w-[760px]">
        <thead><tr className="text-left text-[10px] uppercase tracking-widest text-[#A8A8AD] border-b border-[#35353B]">
          <th className="py-2 pr-3">Supplier</th><th className="py-2 pr-3">Rating</th><th className="py-2 pr-3 text-right">Selesai</th><th className="py-2 pr-3 text-right">Tingkat Selesai</th>
          <th className="py-2 pr-3 text-right">Pelanggaran</th><th className="py-2 pr-3 text-right">Batal tanpa penalti</th><th className="py-2 pr-4 text-right">Nilai Selesai</th><th className="py-2">Status</th></tr></thead>
        <tbody>{rows.map((s) => (
          <tr key={s.id} data-testid={`rep-row-${s.id}`} className="border-b border-[#35353B]">
            <td className="py-3 text-[#F5F3ED]">{s.name}<div className="text-xs text-[#A8A8AD]">{s.email}</div></td>
            <td className="py-3"><Stars rating={s.rating} /></td>
            <td className="py-3 text-right text-[#F5F3ED]">{s.completed}</td>
            <td className="py-3 text-right text-[#F5F3ED]">{s.completion_rate != null ? `${s.completion_rate}%` : "—"}</td>
            <td data-testid={`rep-violations-${s.id}`} className={`py-3 text-right font-bold ${s.violations ? "text-[#F06464]" : "text-[#A8A8AD]"}`}>{s.violations}</td>
            <td className="py-3 text-right text-[#A8A8AD]">{s.cancelled_no_fault}</td>
            <td className="py-3 text-right text-[#D4AF37]">{fmtIDR(s.completed_value_idr)}</td>
            <td className="py-3">{s.blocked ? <button data-testid={`rep-unblock-${s.id}`} onClick={() => unblock(s)} className="text-[10px] font-bold px-2 py-1 border border-[#F06464] text-[#F06464] rounded-sm hover:bg-[#F06464] hover:text-[#101114]">DIBLOKIR · Buka</button>
              : s.warning ? <span className="text-[10px] font-bold px-2 py-1 border border-[#F2D98D] text-[#F2D98D] rounded-sm">PERINGATAN</span>
              : <span className="text-[10px] font-bold px-2 py-1 border border-[#35C78A] text-[#35C78A] rounded-sm">BAIK</span>}</td>
          </tr>))}
          {rows.length === 0 && <tr><td colSpan="8" className="py-10 text-center text-[#A8A8AD]">Belum ada supplier</td></tr>}</tbody>
      </table>
    </div>
  );
}
